import React, { Fragment, useCallback, useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";

import { FaCheck, FaClock, FaTimes, FaTrash } from "react-icons/fa";

import CreaCertificaciones from "../Modals/CreaCertificaciones";
import { descargarDocumento } from "../Seguridad/DescargarDocumento";

const API_URL = "https://suadesarrollo.azurewebsites.net/api";

const AUTH = {
  username: "BasicAuth@icontec.org",
  password: "yQLzqmR7eZSuAmQZUqhY",
};

function CertificacionesSolicitud({ idSolicitud }) {
  const cookie = new Cookies();

  const tipoUsuario = Number(cookie.get("tipo_Usuario"));
  const idUsuario = cookie.get("id");

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [processingId, setProcessingId] = useState(null);

  // Tipo 1: aprobar y rechazar
  const puedeAprobar = tipoUsuario === 1;

  // Tipo 2: crear y eliminar
  const puedeGestionar = tipoUsuario === 2;

  // Tipo 1 y 2 ven acciones
  const tieneAcciones = puedeAprobar || puedeGestionar;

  /**
   * Obtener certificaciones
   */
  const getData = useCallback(async () => {
    if (!idSolicitud) return;

    try {
      setLoading(true);

      const response = await axios.get(
        `${API_URL}/ObtenerCertificados/${idSolicitud}`,
        {
          auth: AUTH,
        },
      );

      setList(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error al obtener certificaciones:", error);
      setList([]);
    } finally {
      setLoading(false);
    }
  }, [idSolicitud]);

  /**
   * Eliminar certificación
   * Solo tipo usuario 2
   */
  const handleDelete = useCallback(
    async (id) => {
      const confirmar = window.confirm(
        "¿Seguro que deseas eliminar esta certificación?",
      );

      if (!confirmar) return;

      try {
        setProcessingId(id);

        await axios.delete(`${API_URL}/EliminarCertificadosPorId/${id}`, {
          auth: AUTH,
          data: {
            TipoAccion:
              "Eliminación de registro en sistema de control de calidad",
            IdUsuario: idUsuario,
          },
        });

        setList((prev) => prev.filter((item) => item.id !== id));

        alert("Certificación eliminada correctamente.");
      } catch (error) {
        console.error("Error al eliminar certificación:", error);

        alert(
          "No fue posible eliminar la certificación. Por favor, intente nuevamente.",
        );
      } finally {
        setProcessingId(null);
      }
    },
    [idUsuario],
  );

  /**
   * Aprobar / rechazar certificación
   */
  const handleAprobacion = useCallback(async (certificadoId, aprobacion) => {
    const accion = aprobacion ? "aprobar" : "rechazar";

    const confirmar = window.confirm(
      `¿Está seguro de que desea ${accion} esta certificación?`,
    );

    if (!confirmar) return;

    try {
      setProcessingId(certificadoId);

      await axios.put(
        `${API_URL}/ActualizarEstadoCertificados/${certificadoId}/${aprobacion}`,
        {},
        {
          auth: AUTH,
        },
      );

      // Actualizar estado local
      setList((prev) =>
        prev.map((item) =>
          item.id === certificadoId
            ? {
                ...item,
                aprobada: aprobacion,
                aprobacionRevisada: true,
              }
            : item,
        ),
      );

      alert(
        aprobacion
          ? "Certificación aprobada correctamente."
          : "Certificación rechazada correctamente.",
      );
    } catch (error) {
      console.error(`Error al ${accion} certificación:`, error);

      alert(
        `No fue posible ${accion} la certificación. Por favor, intente nuevamente.`,
      );
    } finally {
      setProcessingId(null);
    }
  }, []);

  /**
   * Cargar información
   */
  useEffect(() => {
    getData();
  }, [getData]);

  /**
   * Mostrar estado
   */
  const renderEstado = (item) => {
    // No ha sido revisada
    if (item.aprobacionRevisada === false) {
      return (
        <span className="badge badge-warning">
          <FaClock className="mr-1" />
          Pendiente de revisión
        </span>
      );
    }

    // Ya fue revisada y fue aprobada
    if (item.aprobacionRevisada === true && item.aprobada === true) {
      return (
        <span className="badge badge-success">
          <FaCheck className="mr-1" />
          Aprobado
        </span>
      );
    }

    // Ya fue revisada y fue rechazada
    if (item.aprobacionRevisada === true && item.aprobada === false) {
      return (
        <span className="badge badge-danger">
          <FaTimes className="mr-1" />
          Rechazado
        </span>
      );
    }

    // Por seguridad, si llegan valores inesperados
    return <span className="badge badge-secondary">Estado no definido</span>;
  };

  /**
   * Acciones de aprobación
   */
  const renderAccionesAprobacion = (item) => {
    const isProcessing = processingId === item.id;

    return (
      <div className="d-flex justify-content-center">
        <button
          type="button"
          className="btn btn-success btn-sm mr-2"
          disabled={isProcessing}
          onClick={() => handleAprobacion(item.id, true)}
        >
          <FaCheck className="mr-1" />

          {isProcessing ? "Procesando..." : "Aprobar"}
        </button>

        <button
          type="button"
          className="btn btn-danger btn-sm"
          disabled={isProcessing}
          onClick={() => handleAprobacion(item.id, false)}
        >
          <FaTimes className="mr-1" />

          {isProcessing ? "Procesando..." : "Rechazar"}
        </button>
      </div>
    );
  };

  return (
    <Fragment>
      <div className="container">
        <div className="text-center">
          <div className="container-fluid">
            <div className="card shadow mb-4">
              {/* HEADER */}
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold text-primary">
                  Certificaciones
                </h6>
              </div>

              <div className="card-body">
                {/* SOLO TIPO 2 CREA */}
                {puedeGestionar && (
                  <div className="mb-4">
                    <CreaCertificaciones
                      idSolicitud={idSolicitud}
                      onCreated={getData}
                    />
                  </div>
                )}

                <div className="table-responsive">
                  <table
                    className="table table-bordered table-hover"
                    width="100%"
                    cellSpacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Certificación</th>
                        <th>Archivo</th>
                        <th>Estado</th>

                        {tieneAcciones && <th>Acciones</th>}
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td
                            colSpan={tieneAcciones ? 5 : 4}
                            className="text-center"
                          >
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="sr-only">Cargando...</span>
                            </div>

                            <div className="mt-2">
                              Cargando certificaciones...
                            </div>
                          </td>
                        </tr>
                      ) : list.length === 0 ? (
                        <tr>
                          <td
                            colSpan={tieneAcciones ? 5 : 4}
                            className="text-center text-muted"
                          >
                            No existen certificaciones registradas.
                          </td>
                        </tr>
                      ) : (
                        list.map((item) => {
                          const isProcessing = processingId === item.id;

                          return (
                            <tr key={item.id}>
                              {/* ID */}
                              <td>{item.id}</td>

                              {/* NOMBRE */}
                              <td>{item.nombre || "Sin información"}</td>

                              {/* ARCHIVO */}
                              <td>
                                {item.adjunto ? (
                                  <button
                                    type="button"
                                    className="btn btn-success btn-sm"
                                    onClick={() =>
                                      descargarDocumento(item.adjunto)
                                    }
                                  >
                                    Descargar
                                  </button>
                                ) : (
                                  <span className="text-muted">
                                    Sin archivo
                                  </span>
                                )}
                              </td>

                              {/* ESTADO */}
                              <td>{renderEstado(item)}</td>

                              {/* ACCIONES */}
                              {tieneAcciones && (
                                <td className="text-center">
                                  {/* TIPO 1 */}
                                  {puedeAprobar &&
                                    renderAccionesAprobacion(item)}

                                  {/* TIPO 2 */}
                                  {puedeGestionar && (
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-sm"
                                      title="Eliminar"
                                      disabled={isProcessing}
                                      onClick={() => handleDelete(item.id)}
                                    >
                                      <FaTrash className="mr-1" />

                                      {isProcessing
                                        ? "Eliminando..."
                                        : "Eliminar"}
                                    </button>
                                  )}
                                </td>
                              )}
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default CertificacionesSolicitud;
